import { Checkbox, SimpleGrid, Text } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { Symptom } from 'models/generic';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';

export const SymptomsFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();
  const dataField = 'data.heartRhythmMeasurement.symptomsCondition';

  return (
    <AccordionWithSwitch title={t('symptoms_label')} dataField={dataField}>
      <Text size={'xs'} fs={'italic'} mb={-5}>
        {t('symptoms_condition_description')}
      </Text>
      <Checkbox.Group
        {...getInputProps(`${dataField}.symptoms`)}
        error={displayFormError({ errors, dataField: `${dataField}.symptoms`, label: t('empty_value_select') })}
      >
        <SimpleGrid cols={4} verticalSpacing={'xs'} mb={'xs'}>
          {Object.values(Symptom)
            .filter((value) => value !== Symptom.Anxiety)
            .map((symptom) => (
              <Checkbox key={symptom} value={symptom} label={t(`symptom_${symptom}`)} disabled={values.formDisabled} />
            ))}
        </SimpleGrid>
      </Checkbox.Group>
    </AccordionWithSwitch>
  );
};
